<template>
  <div
    :class="[
      $style.wrapper,
      !isUserEmailVerified && $style.centered
    ]"
  >
    <BaseLoading
      v-if="isPrizesLoading || isUserLoading"
      full-screen
    />
    <template v-else>
      <template v-if="!isUserEmailVerified">
        <TheVerifyEmail />
      </template>
      <template v-else>
        <template v-if="prizes.length">
          <div class="w-100 d-flex flex-column">
            <TheWinOverview
              v-for="prize in prizes"
              :key="`prize-${prize.id}`"
              :win-count="prize.winCount"
              :prize="prize.prize"
              :is-expired="prize.isExpired"
              :expiration-date="prize.expirationDate"
              :currency="prize.currency"
              :position="prize.position"
              :league-name="prize.round.season.league.name[$i18n.locale]"
              :round-name="prize.round.name[$i18n.locale]"
              :round-id="prize.round.id"
              :win-id="prize.id"
              :win-status="prize.status"
              :sport-name="prize.round.season.league.sport.name[$i18n.locale]"
              :date="prize.date"
              :type="prize.type"
            />
          </div>
        </template>
        <BaseAlert v-else>
          {{ $t('no-prices-msg') }}
        </BaseAlert>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheWinOverview from './Components/TheWinOverview'
import BaseAlert from '@/components/Atoms/BaseAlert'
import TheVerifyEmail from '@/pages/Auth/Routes/EmailVerification/Components/TheVerifyEmail'

export default {
  name: 'Prizes',
  components: {
    TheVerifyEmail,
    BaseAlert,
    TheWinOverview,
    BaseLoading,
  },
  metaInfo() {
    return {
      title: this.$t('page-titles.prizes'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.prizes') },
      ],
    }
  },
  computed: {
    ...mapState({
      isUserLoading: state => state['auth'].isUserLoading,
      isPrizesLoading: state => state['prizes/index'].isPrizesLoading,
      prizes: state => state['prizes/index'].prizes,
    }),
    ...mapGetters({
      isUserEmailVerified: 'auth/isUserEmailVerified',
    }),
  },
  created: function() {
    this.fetchPrizes()
  },
  methods: {
    ...mapActions({
      fetchPrizes: 'prizes/index/fetchPrizes',
    }),
  },
}
</script>

<style module>
  .wrapper {
    width: 100%;
    flex: 1;
    display: flex;
    align-items: flex-start;
  }
  .centered {
    align-items: center;
    justify-content: center;
  }
</style>
